export const REMOVE_AUTH_INFO = "authserver/REMOVE_AUTH_INFO";
export const SET_ACCESS_TOKEN_INFO = "authserver/SET_ACCESS_TOKEN_INFO";
export const SET_ID_TOKEN_INFO = "authserver/SET_ID_TOKEN_INFO";
